import { render, staticRenderFns } from "./DashboardBoxRecenti.vue?vue&type=template&id=9bd27e3e&scoped=true&"
import script from "./DashboardBoxRecenti.vue?vue&type=script&lang=js&"
export * from "./DashboardBoxRecenti.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBoxRecenti.vue?vue&type=style&index=0&id=9bd27e3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd27e3e",
  null
  
)

export default component.exports